import styled from 'styled-components';

// Notification Panel Header Titlebar
export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #f0f0f0;
  background: #ffffff;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BellIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const Title = styled.div`
  font-family: 'Montserrat Medium';
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ThreeDotsButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  transition: background-color 0.2s ease;
  border-radius: 4px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const UnreadToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UnreadLabel = styled.span`
  font-family: 'Montserrat Regular';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
`;

export const DropdownMenu = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 999999;
  min-width: 120px;
  padding: 6px 0;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
`;

export const DropdownMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  font-family: 'Montserrat Regular';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

// Notification Panel Header Search
export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 8px 16px 8px 40px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-family: 'Montserrat Regular';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  background-color: #f5f5f5;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #0095ff;
    background-color: #ffffff;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.45);
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-33%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.45);
  pointer-events: none;
`;


// Notification Panel Header Filters
export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 16px 0px;
  flex-wrap: wrap;
`;

export const FilterButton = styled.button`
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid ${props => props.active ? '#99D5FF' : '#E0E0E0'};
  background-color: ${props => props.active ? '#E6F4FF' : '#FFFFFF'};
  color: ${props => props.active ? '#0095FF' : '#0C0D0D'};
  font-family: 'Montserrat Regular';
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${props => props.active ? '#99D5FF' : '#C9CBCF'};
    background-color: ${props => props.active ? '#E6F4FF' : '#F2F2F3'};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const FilterIconButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${props => props.active ? '#99D5FF' : '#E0E0E0'};
  background-color: ${props => props.active ? '#E6F4FF' : '#FFFFFF'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    border-color: ${props => props.active ? '#99D5FF' : '#C9CBCF'};
    background-color: ${props => props.active ? '#E6F4FF' : '#F2F2F3'};
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 16px;
    height: 16px;
    stroke: ${props => props.active ? '#0095FF' : '#0C0D0D'};
  }
`;

export const FilterDropdownMenu = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 999999;
  min-width: 280px;
  max-width: 320px;
  max-height: 500px;
  overflow-y: auto;
  padding: 16px 0;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
`;

export const DropdownSection = styled.div`
  padding: 0 16px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  font-family: 'Montserrat SemiBold';
  font-size: 14px;
  font-weight: 600;
  color: #0C0D0D;
  margin-bottom: 6px;
  text-transform: capitalize;
`;

export const CheckboxItem = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 3px 0;
  cursor: pointer;
  font-family: 'Montserrat Regular';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  user-select: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }

`;